/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ExtensibleNode } from '../../../core/models/ExtensibleNode';
import { IReferenceNode } from '../../../core/models/IReferenceNode';
import { INamed } from '../../../core/models/common/INamed';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';
import { Oas30LinkParameterExpression } from './Oas30LinkParameterExpression';
import { Oas30LinkRequestBodyExpression } from './Oas30LinkRequestBodyExpression';
import { Oas30LinkServer } from './Oas30LinkServer';
import { Document } from '../../../core/models/Document';
import { Node } from '../../../core/models/Node';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends ExtensibleNode
 * @author eric.wittmann@gmail.com
 */
export class Oas30Link extends ExtensibleNode implements INamed, IReferenceNode {
    /*private*/ _name : string;

    public $ref : string;

    public operationRef : string;

    public operationId : string;

    public parameters : any = <any>({});

    public requestBody : Oas30LinkRequestBodyExpression;

    public description : string;

    public server : Oas30LinkServer;

    public constructor(name : string) {
        super();
        if(this._name===undefined) this._name = null;
        if(this.$ref===undefined) this.$ref = null;
        if(this.operationRef===undefined) this.operationRef = null;
        if(this.operationId===undefined) this.operationId = null;
        if(this.requestBody===undefined) this.requestBody = null;
        if(this.description===undefined) this.description = null;
        if(this.server===undefined) this.server = null;
        this._name = name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitLink(this);
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#getName()
     * @return {string}
     */
    public getName() : string {
        return this._name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#rename(java.lang.String)
     * @param {string} newName
     */
    public rename(newName : string) {
        this._name = newName;
    }

    /**
     * 
     * @return {string}
     */
    public getReference() : string {
        return this.$ref;
    }

    /**
     * 
     * @param {string} reference
     */
    public setReference(reference : string) {
        this.$ref = reference;
    }

    /**
     * Creates a link parameter expression.
     * @param {string} name
     * @param {string} value
     * @return {Oas30LinkParameterExpression}
     */
    public createLinkParameterExpression(name : string, value : string) : Oas30LinkParameterExpression {
        let rval : Oas30LinkParameterExpression = new Oas30LinkParameterExpression(name, value);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Adds a link parameter expression.
     * @param {string} name
     * @param {Oas30LinkParameterExpression} expression
     */
    public addLinkParameterExpression(name : string, expression : Oas30LinkParameterExpression) {
        /* put */(this.parameters[name] = expression);
    }

    /**
     * Adds a link parameter expression.
     * @param {string} name
     * @param {string} expression
     * @return {Oas30LinkParameterExpression}
     */
    public addLinkParameter(name : string, expression : string) : Oas30LinkParameterExpression {
        let model : Oas30LinkParameterExpression = this.createLinkParameterExpression(name, expression);
        this.addLinkParameterExpression(name, model);
        return model;
    }

    /**
     * Gets a single link parameter expression by name.
     * @param {string} name
     * @return {Oas30LinkParameterExpression}
     */
    public getLinkParameterExpression(name : string) : Oas30LinkParameterExpression {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.parameters, name);
    }

    /**
     * Removes a single link parameter expression and returns it.  This may return null or undefined if none found.
     * @param {string} name
     * @return {Oas30LinkParameterExpression}
     */
    public removeLinkParameterExpression(name : string) : Oas30LinkParameterExpression {
        return /* remove */(map => { let deleted = this.parameters[name];delete this.parameters[name];return deleted;})(this.parameters);
    }

    /**
     * Gets a list of all link parameter expressions.
     * @return {Oas30LinkParameterExpression[]}
     */
    public getLinkParameterExpressions() : Array<Oas30LinkParameterExpression> {
        let rval : Array<Oas30LinkParameterExpression> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.parameters));
        return rval;
    }

    /**
     * Creates a link request body expression.
     * @param {string} value
     * @return {Oas30LinkRequestBodyExpression}
     */
    public createLinkRequestBodyExpression(value : string) : Oas30LinkRequestBodyExpression {
        let rval : Oas30LinkRequestBodyExpression = new Oas30LinkRequestBodyExpression(value);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Creates an OAS 3.0 Server object.
     * @return {Oas30LinkServer}
     */
    public createServer() : Oas30LinkServer {
        let rval : Oas30LinkServer = new Oas30LinkServer();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }
}
Oas30Link["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Link";
Oas30Link["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed"];




